export default theme => ({
    editorContainer:{
        display: "flex",
        backgroundColor: "#eaedf1",
        alignItems: "flex-start"
        /* backgroundColor: theme.palette.background.light,  */
    },
    fieldListHolder:{
       /*  borderTop: `3px solid ${theme.palette.primary.main}` */
    },
    responsePreview:{
        flex:1,
        padding: theme.spacing(5),
        position: "sticky",
        top: 60,
        [theme.breakpoints.down('lg')]: {
            padding: theme.spacing(3)
        }
    },
    responseDetails:{
        flex: 1,
        padding: theme.spacing(5),
        boxShadow: "5px 0px 10px -10px #5c6078",
        zIndex: 1,
        minHeight: "100%",
        background: theme.palette.background.paper,
        minWidth: "50%",
        [theme.breakpoints.down('lg')]: {
            padding: theme.spacing(3)
        }
    },
    previewContainer:{
        padding: theme.spacing(3),
        marginTop: 30 
    },
    inputPreview: {
        padding: 15,
        color: theme.palette.text.light,
        border: `1px solid #DFE3E8`,
        borderRadius: 5,
        marginTop: 20
    },
    detailsSectionTitle: {
        margin: "35px 0",
        opacity: .9,
        "&:first-of-type":{marginTop:20}
    },
    fieldList: {
        padding: 15,
        paddingRight: 35,
        border: `1px solid ${theme.palette.background.light}`,
        background: "#fff",
        position: "relative",
        borderRadius: 3,
        transition: "border 1s" 
    },
    actionIcon: {
        opacity: .5, 
        color: "red",
        "&:hover":{
            opacity: 1
        }
    },
    previewActionButton: {
        backgroundColor: "#007a5a!important",
        color: theme.palette.background.paper
    },
    previewActions: {
        marginTop: 25,
        textAlign: "right",
        "& button":{
            backgroundColor: theme.palette.background.paper,
            padding: "8px 16px",
            fontWeight: 500,
            fontFamily: "inherit",
            borderRadius: 5,
            marginLeft: 5,
            border: `1px solid #e3e5ed`,
        }
    },
    previewTitle: {
        display: "flex",
        opacity: .9,
        alignItems: "center",
        "& img":{
            height: 35,
            width: 35,
            marginRight: 10
        }
    },
    saveButton: {
        marginTop: 80, 
        marginLeft: 10,
        float: "right"
    },
    dndIcon: {
        color: "lightgray",
        marginLeft: -10,
        marginRight: 10
    },
    noFieldsSign: {
        opacity: .2,
        textAlign: "center",
        margin: "auto",
        marginTop: 200,
        maxWidth: 400
    },
    customAddButton: {
        background: theme.palette.background.light,
        padding: 15,
        "&:hover":{
            background: theme.palette.background.paper
        }
    }, customTabs:{
        background: theme.palette.background.light,
        borderRadius: 5
    }
  });
  